import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthguardGuard } from 'projects/is-ui-kit/src/lib/components/is-login/auth-guard.guard';
import { LoginComponent } from './modules/components/login/login.component';
import { CreateUserComponent } from './modules/components/create-user/create-user.component';
import { EmailResetPasswordComponent } from './modules/components/reset-password/email-reset-password/email-reset-password.component';
import { ResetPasswordComponent } from './modules/components/reset-password/reset-password/reset-password.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'create-user', component: CreateUserComponent },
  { path: 'request-reset-password', component: EmailResetPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: '', loadChildren: () => import('./modules/modules.module').then((m) => m.ModulesModule), canActivate: [AuthguardGuard] }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
